module.exports = __webpack_public_path__ + "img/service1_content.51210cf5.png";